// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractSimpleModuleUi } from '../_abstract/ui';
let AnchorModuleUi = class AnchorModuleUi extends AbstractSimpleModuleUi {
};
AnchorModuleUi = __decorate([
    Component({
        name: 'AnchorModuleUi',
        template: '<component :is="component" class="anchor-module" />'
    })
], AnchorModuleUi);
export { AnchorModuleUi };
